module.exports = __webpack_public_path__ + "static/media/enteromar.e69dd139.png";